<template>
  <div class="custom-tree-node" @mouseenter="mouseEnterHandler" :class="{'show-more':moreBtnShow}">
    <div class="tree-name" :id="`${data._id}_navtree_nodeid`" v-context-menu="{ params: params, data: $menuButtons }" @click.stop="currNodeChange">
      <span class="tree-name-label">
        <template v-if="!$navTreeCtrl.icons">
          <i v-if="data[$navTreeCtrl.defaultProps.children] !== undefined && $navTreeCtrl.showIcon" :class="['iconfont',node.expanded ? 'icon-dakai' : 'icon-wenjianjia']" />
          <i v-else-if="$navTreeCtrl.showIcon" class="iconfont icon-shiyongwendang" />
          <slot name="nodeLabel" :data="data">
            <span v-html="dsf.safe.xss(data[$navTreeCtrl.defaultProps.label])"></span>
          </slot>
        </template>
        <template v-else>
          <i v-for="(icon, iconI) in $navTreeCtrl.icons.filter((icon) => {
               return getIconClass(icon, node)[0] != '';
             })"
             :key="iconI"
             class="iconfont"
             :class="getIconClass(icon, node)"
             :style="{ color: icon.color }" />
        </template>
        <slot name="nodeLabel" :data="data">
          <span :title="dsf.safe.xss(data[$navTreeCtrl.defaultProps.label])" v-html="dsf.safe.xss(data[$navTreeCtrl.defaultProps.label])"></span>
        </slot>
      </span>
      <span @click.stop v-if="needGetContextMenuData">
        <div v-if="!contextMenuData" class="ds-no-padding edit-span">
          <i class="iconfont icon-gengduo1" :class="loadingBtns?'el-icon-loading':'icon-gengduo1'" @click="getContextMenuData"></i>
        </div>
        <DsfButtonBar v-if="!contextMenuData" ref="btnCtrl" class="ds-no-padding edit-span" :local="data"></DsfButtonBar>
        <DsfButtonBar v-else @popoverState="popoverStateFn" ref="btnCtrl" class="ds-no-padding edit-span" :render-button="$navTreeCtrl.renderRowButton" :max-number="$navTreeCtrl.buttonsMaxNumber" more-button-style="icon-text" more-button-text="" :buttons="contextMenuData" :emit-prefix="'row-button'" :local="data" :moreBtnColNum="$navTreeCtrl.moreBtnColNum" size="small" align="left">
        </DsfButtonBar>
      </span>
      <span @click.stop v-else-if="isMouseEnter && buttons.length>0">
        <DsfButtonBar @popoverState="popoverStateFn" ref="btnCtrl" class="ds-no-padding edit-span" :render-button="$navTreeCtrl.renderRowButton" :max-number="$navTreeCtrl.buttonsMaxNumber" more-button-style="icon-text" more-button-text="" :buttons="buttons" :emit-prefix="'row-button'" :local="data" :moreBtnColNum="$navTreeCtrl.moreBtnColNum" size="small" align="left">
        </DsfButtonBar>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "navTreeNode",
  inject: {
    $navTreeCtrl: {
      default: null
    }
  },
  props: {
    node: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      data: {},
      treeClickNum: 0,
      treeClickTemp: null,
      params: {},
      buttons: [],
      isMouseEnter: false,
      moreBtnShow: false,
      needGetContextMenuData: false,
      contextMenuData: null,
      loadingBtns: false
    };
  },
  computed: {
    $menuButtons() {
      let menusButtonsProp = [];
      _.forEach(this.buttons, (btn) => {
        if (btn.isContextmenu) {
          menusButtonsProp.push(btn);
        }
      });
      if (menusButtonsProp?.length > 0) {
        let menusButtonsReal = [];
        _.forEach(menusButtonsProp, (btn) => {
          let btnParams = [];
          if (btn.isUpload) {
            btnParams = this.getButtonParams(btn);
          }
          let uploadState = false;
          if (btn.isUpload) {
            uploadState = {
              action: dsf.url.getWebPath(btnParams[0]),
              data: btnParams[1],
              accept: btnParams[2]
                ?.split("|")
                .map((el) => {
                  el = el.toLowerCase();
                  return dsf.mime[el] || el;
                })
                .join(",")
            };
          }
          menusButtonsReal.push({
            icon: (btn.icon.slice(0, 5) === "icon-" ? "" : "icon-") + btn.icon,
            name: btn.text || btn.caption,
            upload: uploadState,
            hide: (res) => {
              this.$refs.btnCtrl?.$refs?.["more-button-popover"]?.doClose?.();
              const btnBarCtrl = this.$refs.btnCtrl;
              if (btnBarCtrl) {
                return !btnBarCtrl.showAndHide(btn);
              } else {
                return true;
              }
            },
            disabled: (res) => {
              const btnBarCtrl = this.$refs.btnCtrl;
              if (btnBarCtrl) {
                btnBarCtrl.disabledFactor(btn);
                return btn.disabled;
              } else {
                return true;
              }
            },
            handler: (res) => {
              this.$refs.btnCtrl.clickHandler(btn, res.el, res.response?.data);
            }
          });
        });
        return menusButtonsReal;
      }
      return [];
    }
  },
  created() {
    this.needGetContextMenuData = this.$navTreeCtrl.$listeners.contextMenuData ? true: false;
    this.data = this.node.data;
    this.params = { $vm: this.$navTreeCtrl, ...this.node };
  },
  mounted() {
    this.scrollEl = dsf.findScrollEl(this.$el);
    this.scrollEl.addEventListener("scroll",this.handlerScroll, true)
  },
  methods: {
    getContextMenuData(){
      this.loadingBtns = true;
      let data = this.buttons;
      _.forEach(data,(item)=>{
        item.name = item.text;
      })
      new Promise((resolve)=> {
        this.$navTreeCtrl.$dispatch("contextMenuData", { params:this.node, data, resolve });
      }).then((btns) => {
        this.contextMenuData = btns || [];
        this.$nextTick(()=>{
          this.loadingBtns = false;
          this.$refs.btnCtrl.$refs["more-button-popover"].showPopper = true;
        })
      })
    },
    popoverStateFn(state){
      this.moreBtnShow = !state;
    },
    handlerScroll(evt){
      // 更多按钮被打开时：随着滚动，超出可视区域的关闭更多按钮
      let scrollTop = evt.target.scrollTop;
      const _height = this.$navTreeCtrl.$el.getElementsByClassName("ds-tree-box")[0].clientHeight;
      if(this.isMouseEnter && this?.$refs?.btnCtrl){
        if(!this.$refs.btnCtrl.moreFold){
          let offsetTop = this.$el.offsetTop;
          let clientHeight = this.$el.clientHeight;
          if(scrollTop > offsetTop + clientHeight || offsetTop>scrollTop + _height){
            this.$refs.btnCtrl?.$refs?.["more-button-popover"]?.doClose?.();
          }
        }
      }
    },
    mouseEnterHandler() {
      this.isMouseEnter = true;
    },
    nodeContextmenu(e) {
      document.body.click();
      e.stopPropagation();
      e.preventDefault();
      let fn = Vue.directive("contextMenu").contextMenuClick;
      fn(
        {
          x: e.clientX,
          y: e.clientY
        },
        this.params,
        this.$menuButtons,
        e.target,
        e
      );
    },
    createMenuButtonBar() {
      let inject = {};
      ["$vm", "$page", "$form", "$dialog"].forEach((it) => {
        inject[it] = {
          default: this.$navTreeCtrl[it]
        };
      });
      let DsfButtonBar = Vue.extend({
        mixins: [window.$components["platform"]["DsfButtonBar"]],
        inject
      });
      let btnBarCtrl = new DsfButtonBar({
        propsData: {
          isDesign: false,
          owner: this,
          local: this.node.data
        }
      });
      return btnBarCtrl;
    },
    currNodeChange() {
      this.treeClickNum++;
      let vm = this;
      vm.treeClickTemp = window.setTimeout(function () {
        vm.$navTreeCtrl.currNodeChange(vm.node.data, vm.node);
        vm.$navTreeCtrl.$refs.tree.setCurrentKey(vm.node.key);
        if (vm.treeClickNum >= 2 && vm.$navTreeCtrl.dblclickIsOpen) {
          if (vm.node.expanded) {
            vm.node.expanded = false;
          } else {
            vm.node.expand();
          }
          window.getSelection ? window.getSelection().removeAllRanges() : document.getSelection.empty();
        }
        vm.treeClickNum = 0;
        clearTimeout(vm.treeClickTemp);
      }, 300);
    },
    getIconClass(iconData, nodeData) {
      if (dsf.express.eval(iconData.code, nodeData.data)) {
        if (nodeData.expanded) {
          return [iconData.iconExpand || ""];
        } else {
          return [iconData.iconFold || ""];
        }
      }
      return [""];
    },
    getMenuButtons() {},
    isFunctionCode(code) {
      let rfunction = /^\s*function(\s+\w*)?\(.*\)\s*{/g;
      return rfunction.test(code);
    },
    execFunction(button, owner, v) {
      let code = [
        "var result= (" + v + ").call(this,data,button,owner,self);",
        "data=null;",
        "button=null;",
        "owner=null;",
        "self=null;",
        "return result;"
      ];
      let fn = new Function("data", "button", "owner", "self", code.join("\n"));
      let result = fn.call(this.$vm, this.local, button, owner, this);
      result = this.$replace(result, this.local);
      return result;
    },
    getButtonParams(button) {
      let owner = this.$navTreeCtrl.owner || this.$navTreeCtrl;
      let params = _.map(button.params, (p) => {
        let paramValue = null;
        if (dsf.type(p.value) == "string") {
          let v = p.value.trim();
          if (this.isFunctionCode(v)) {
            paramValue = this.execFunction(button, owner, v);
          } else {
            paramValue = v;
          }
        } else if (dsf.type(p.value) == "object") {
          if (p.value.type == "static") {
            let v = p.value.code || "";
            paramValue = v;
          } else if (p.value.type == "switch") {
            let v = this.local[p.value.code.field] || "";
            paramValue = v;
          } else {
            let v = p.value.code;
            if (this.isFunctionCode(v)) {
              paramValue = this.execFunction(button, owner, v);
            }
          }
        }
        if (paramValue == "" || dsf.isUnDef(paramValue)) {
          paramValue = p.default || null;
        }
        if (paramValue === "false") {
          paramValue = false;
        } else if (paramValue === "true") {
          paramValue = true;
        }
        return paramValue;
      });
      return params;
    },
    getRowButtons(buttons) {
      return dsf.mix(true, [], buttons || []);
    }
  },
  beforeDestroy() {
    this.treeClickTemp && clearTimeout(this.treeClickTemp);
    this.menuButtonBar && this.menuButtonBar.$destroy();
    this.scrollEl.removeEventListener("scroll",this.handlerScroll, true);
  },
  watch: {
    "$navTreeCtrl.rowButtons": {
      handler(v, ov) {
        this.buttons = this.getRowButtons(this.$navTreeCtrl.rowButtons);
      },
      immediate: true
    }
  }
};
</script>
